import { Card, CardContent, Container, Grid } from '@material-ui/core';
import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import FormRenderer from 'src/components/FormBuilder/forms/form-renderer';
import LoadingContainer from 'src/components/LoadingContainer/LoadingContainer';
import { APP_CONSTANT } from 'src/constants';
import { t } from 'src/i18n';
import UpcomingAppointment from './components/UpcomingAppointment.component';
import UserDocument from './components/UserDocumentAttention.component';
import { useStyles } from './Dashboard.style';
import { pathOr } from 'ramda';
import { useCookies } from 'react-cookie';
import GenericError from 'src/components/GenericError/GenericError';
import { AppContext } from 'src/context/AppContextProvider';
import Routes from '../../modules/Navigator/Navigator.route';
import { getOnlineBookingFormStatus } from 'src/services/onlineAppointmentBooking.service';
import AccountInfo from './components/AccountInfo.component';
import Api from '../../components/FormBuilder/forms/components/form-field-types/appointment-booking/api.jsx';
import { parseJSON } from 'src/utils/common.util';
interface IProps {
  cookies: {
    userInfo: {
      name: { nameFirst: string; nameLast: string };
    };
    role: string;
    token: string;
  };
}

const DashboardView: React.FC<IProps> = ({ cookies }) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [appointmentData, setAppointmentData] = React.useState<any>({});
  const [isError, setIsError] = React.useState<boolean>(false);
  const context = useContext(AppContext);
  const [cookie] = useCookies([]);
  const contactId = pathOr('', ['id'])(cookie.userInfo);
  const isLoggedIn = [
    APP_CONSTANT.ROLE_SINGLE_USER,
    APP_CONSTANT.ROLE_LEGAL_GUARDIAN
  ].includes(cookie.role);
  const classes = useStyles();

  const [accountId, setAccountId] = React.useState<string>('');
  const [isGoogleReserveEnabled, setIsGoogleReserveEnabled] = React.useState<boolean>(false);
  const [isSingleLocation, setIsSingleLocation] = React.useState<boolean>(false);

  useEffect(() => {
    const parsedAccountId = (parseJSON('tenantInfo') as any).accountId

    if (parsedAccountId) {
      setAccountId(parsedAccountId)
    }


    const getLocations = async () => {
      const response = await Api.getLocations(parsedAccountId, true)

      return response;
    }

    const getGeneralSettings = async () => {
      const generalSettings = await Api.getPatientPortalPublicGeneralSettings(
        parsedAccountId
      );

      return generalSettings;
    }

    getLocations()
      .then((response) => {
        const locations = response.filter((location: any) => !location.isDeleted)

        if (locations.length === 1) {
          setIsSingleLocation(true)
        }
      })
      .catch(() => {
        setIsError(true);
        setIsLoading(false);
      });

    getGeneralSettings()
      .then((response) => {
        const googleReserveEnabled = response.googleReserveEnabled;

        if (googleReserveEnabled) {
          setIsGoogleReserveEnabled(googleReserveEnabled)
        }
      })
      .catch(() => {
        setIsError(true);
        setIsLoading(false);
      });
  }, [])

  const getAppointmentForm = () => {
    getOnlineBookingFormStatus(isLoggedIn)
      .then((response) => {
        if (!response.isOnlineBookingEnabled && !isLoggedIn) {
          history.push(Routes.PatientDocument);
        }
        setAppointmentData(response);
        setIsLoading(false);
      })
      .catch(() => {
        setIsError(true);
        setIsLoading(false);
      });
  };

  const objectField = {
    fields: [
      { display_name: 'Patient' },
      { display_name: 'Appointment Type' },
      { display_name: 'Provider' },
      { display_name: 'Appointment Date' },
      { display_name: 'Appointment Time' }
    ]
  };

  const userInfo = cookie.userInfo;

  const submission = userInfo
    ? [
      { name_first: pathOr('', ['name', 'nameFirst'])(userInfo) },
      { name_last: pathOr('', ['name', 'nameLast'])(userInfo) },
      { address: userInfo.emailAddress },
      { number: (userInfo.phoneNumbers[0] || {}).number || '' }
    ]
    : [];

  React.useEffect(() => {
    getAppointmentForm();
  }, []);

  return (
    <Container className="dashboard">
      <Grid container={true} spacing={3}>
        <Grid item={true} xs={12} sm={9}>
          {isLoggedIn && (
            <Card className={`${classes.mb30} ${classes.borderRadius15}`}>
              <CardContent className={classes.cardContent}>
                <p
                  className={`${classes.cardTitle} ${classes.mb15} ${classes.ml15}`}
                >
                  {t('dashboard.title.upcomingAppointment')}
                </p>
                <UpcomingAppointment />
              </CardContent>
            </Card>
          )}

          {context.isOABFormPublished && (<>
            {isGoogleReserveEnabled && isSingleLocation && (
              <Card className={`${classes.borderRadius15} ${classes.accountInfoWrapper}`} style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <CardContent>
                    <AccountInfo cookies={cookies} />
                </CardContent>
              </Card>
            )}

            <Card
              className={`${classes.borderRadius15}  ${classes.minHeight150} ${classes.oab}`}
            >
              <CardContent className={classes.cardContent}>
                <LoadingContainer isLoading={isLoading}>
                  {isError ? (
                    <GenericError />
                  ) : (
                    <>
                      {appointmentData.forms && appointmentData.forms.length && (
                        <div className="class-name-form-unique form-booking-appointment">
                          <FormRenderer
                            isShowInformation={true}
                            id={appointmentData.forms[0].formId}
                            checksum={appointmentData.forms[0].checkSum}
                            ownerId={contactId}
                            allowSubmit={true}
                            field={objectField}
                            submission={submission}
                            saveAsGuest={false}
                            type={APP_CONSTANT.APPOINTMENT_BOOKING}
                          />
                        </div>
                      )}
                    </>
                  )}
                </LoadingContainer>
              </CardContent>
            </Card>
          </>

          )}
        </Grid>

        <Grid item={true} xs={12} sm={3}>
          {(context.isOABFormPublished || isLoggedIn) && (
            <Card className={`${classes.borderRadius15}`} style={{ flexGrow: 1 }}>
              <CardContent>
                <UserDocument cookies={cookies} />
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default DashboardView;
